import { render, staticRenderFns } from "./schoolinfolist.vue?vue&type=template&id=946c0098&scoped=true"
import script from "./schoolinfolist.vue?vue&type=script&lang=js"
export * from "./schoolinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946c0098",
  null
  
)

export default component.exports